import { Card } from '@etg/wings';
import { DangerousHtmlContent, Overlay } from '@eti/components';
import { css } from '@eti/styles';

export interface OverlayDrawerForNotificationProps {
  content: string;
  header: string;
  isOpen: boolean;
  onClose: () => void;
}

const drawerInnerStyles = css`
  ul {
    list-style: disc;
    margin: 20px 0;
    padding-left: 24px;

    li {
      margin-bottom: 10px;
    }
  }
`;

const OverlayDrawerForNotification = ({
  content,
  header,
  isOpen,
  onClose,
}: OverlayDrawerForNotificationProps) => (
  <Overlay.Drawer dataTestId="notification-overlay" handleClose={onClose} isOpen={isOpen}>
    <Overlay.Header data-testid="notification-overlay-title" onClose={onClose} title={header} />
    <Overlay.Content data-testid="notification-overlay-content">
      <Card>
        <DangerousHtmlContent className={drawerInnerStyles} content={content} />
      </Card>
    </Overlay.Content>
  </Overlay.Drawer>
);

export default OverlayDrawerForNotification;
